import { Button, Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@pella/sash-framework';
import { useTranslation } from 'react-i18next';
import styles from './EquipmentInfoSection.module.css';

/**
 * Displays equipment information such as site, department, and equipment details.
 * @param {object} root0 - Component props
 * @param {object} [root0.selectedEquipment] - The currently selected equipment object
 * @param {boolean} [root0.scanAgainVisible] - Whether the scan again button should be visible
 * @param {() => void} [root0.handleScanAgain] - Handler for the scan again button click
 * @returns {import('react').ReactElement} The EquipmentInfoSection component
 */
const EquipmentInfoSection = ({ selectedEquipment, scanAgainVisible, handleScanAgain }) => {
  const { t } = useTranslation();
  const notSelectedText = t('notSelected');

  return (
    <>
      <div className={styles.header}>
        <h2 className={styles.headerTitle}>{t('equipmentActionPortalTitle')}</h2>
      </div>
      <div className={styles.divider} />

      <div className={styles.infoRow}>
        <div className={styles.infoItem}>
          <span className={styles.infoLabel}>{t('site')}:</span>
          <span className={styles.infoValue}>{selectedEquipment?.siteId ?? notSelectedText}</span>
        </div>
        <div className={styles.infoItem}>
          <span className={styles.infoLabel}>{t('department')}:</span>
          <span className={styles.infoValue}>{selectedEquipment?.location ?? notSelectedText}</span>
        </div>
        {scanAgainVisible && (
          <div className={styles.infoItem}>
            <Button size='sm' color='primary' onClick={handleScanAgain}>
              {t('scanQRCode')}
            </Button>
          </div>
        )}
      </div>

      <div className={styles.divider} />

      {selectedEquipment && (
        <Accordion>
          <AccordionItem>
            <AccordionTrigger>
              {`${t('equipmentNumber')}: ${selectedEquipment.equipNum} - ${t('description')}: ${selectedEquipment.description}`}
            </AccordionTrigger>
            <AccordionContent>
              <div className={styles.equipmentDetails}>
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>{t('department')}:</span>
                  <span className={styles.detailValue}>{selectedEquipment?.departmentId}</span>
                </div>
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>{t('location')}:</span>
                  <span className={styles.detailValue}>{selectedEquipment?.location}</span>
                </div>
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>{t('costCenter')}:</span>
                  <span className={styles.detailValue}>{selectedEquipment?.costcenterId}</span>
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      )}
    </>
  );
};

export default EquipmentInfoSection;
